// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3r-7z","paramInput":"JobSimulator_paramInput__lzYSW","input":"JobSimulator_input__2h94h"};